module.exports = __webpack_public_path__ + "assets/img/TLSC4-1.4ef83133.jpg";